<template>
    <div class="d-flex">
        <div v-if="svg_icon" class="info_svg_icon">
            <font-awesome-icon :icon="svg_icon"/>
        </div>
        <div class="info_infos">
            <h5 class="info_title">{{ props.title }} </h5>
            <h6 class="info_value sensitive_information">{{ props.info_value }}</h6>
        </div>
    </div>
</template>
<script setup>

const props = defineProps({
    title: {},
    info_value: {},
    svg_icon:{},
});
    
</script>


<style scoped>

.info_infos{
    max-width: 125px;
}

.info_infos h6{
    width: 100%;
}

.info_svg_icon{
    font-size: 14px;
    color: #28bc6d;
    border-radius: 50px;
    margin-left: 0;
    background-color: #ffffff;
    width: 38px;
    height: 38px;
    margin-right: 10px;
    justify-content: center;
    text-align: center;
    align-items: center;
    display: flex;
    padding-bottom: 1px;
    float: left;
    border: 1px #d7d7d7 solid;
}

.info_title{
    font-size: 14px;
    color: #808080;
    margin-bottom: 2px
}

.info_value{
    font-weight: 600;
    font-size: 15px;
    margin: 0;
    display: block!important;
    color: inherit;
}
</style>